import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Dashboard from "../Dashboard/Dashboard_new";
import Masterpage from "../Masterpage/Masterpage";
import EquipmentGroup from "../Equipment-Details/EquipmentGroup";
import Plant from "../Masterpage/Plant/Plant";
import AddCostCenter from "../Masterpage/Plant/CostCenter/AddCostCenter";
import CostCenter from "../Masterpage/Plant/CostCenter/CostCenter";
import BuildingList from "../Building/BuildingList";
import EquipmentList from "../Equipment-Details/Equipments/EquipmentList";
import HerstellerList from "../Equipment-Details/Hersteller/HerstellerList";
import StandardAttributeList from "../Equipment-Details/StandardAttribute/StandardAttributeList";
import PruefGroup from "../Equipment-Details/PruefGroup/PruefGroupList";
import DigitalCheckList from "../Equipment-Details/PruefPlan/PruefPlanList";
import BezeichnungList from "../Equipment-Details/Bezeichnung/BezeichnungList";
import OrganizationsAdmin from "../Masterpage/OrganizationsAdmin";
import PerformanceAnalysis from "../Masterpage/PerformanceAnalysis";
import ExceptionAnalysis from "../Masterpage/ExceptionAnalysis";
import EquipmentDetails from "../Equipment-Details/EquipmentDetails";
import AddEquipment from "../New-Equipment/AddEquipment";
import NavDetails from "../Navigationsbar/Nav-Details/NavDetails";
import GraphDashboard from "../Dashboard/GraphDashboard";
import OrganisationSettings from "../OrganisationSetting/OrganisationSettings";
import Audit from "../AuditDetail/Audit";
import ImportExcel from "../Import-Excel/ImportExcel";
import ConfigurationValidationList from "../Masterpage/ConfigurationValidation/ConfigurationValidationList";
import Benutzerverwaltung from "../Verwaltung/Benutzerverwaltung";
// import ConfigTemplate from "../ConfigTemplate/ConfigTemplate";
// import MainTemplate, { WrapMainTemplate } from "../ConfigTemplate/mainTemplate";
import FeedBackList from "../Masterpage/FeedBack/FeedBackList";
import EmailIndex from "../Email/EmailIndex";
import NotPassedInspection from "../InspectionSupport/indexInspection";
import PrivateRoute from "./PrivateRoute";
import Sidebar from "../Sidebar/Sidebar";
import Navigationsbar from "../Navigationsbar/Navigationsbar";
import SearchEquipment from "../Public-Website/SearchEquipment";
import ManageTicket from "../ManageTicket";
import PublicAccess from "../ManageTicket/PublicAccess";
// import InspectionIndex from "../WebInspection/inspectionIndex";
import CostCenterGroup from "../Cost-Center-Group/CostCenterGroup";
import InspectionReports from "../InspectionReports/index";
import SearchBox_new from "../FilterOptions/SearchComponent/SearchBox_new";
import commonUtils from "../../helpers/commonUtils";
import ExportOrganisationData from "../ExportOrganisationData/ExportOrganisationData";
import ScrappedEquipments from "../Equipment-Details/ScrappedEquipment/ScrappedEquipment";

export function Layout({ children }) {
  return (
    <>
      <Navigationsbar />
      <main className="container-fluid sb-wrapper">
        <Sidebar />
        {children}
      </main>
    </>
  );
}

export default function RouteConfig() {
  function ConditionalRoute() {
    return commonUtils.isAdmin() && !commonUtils.hasManageTicketPermission() ? (
      <Navigate to="/setting/digitalChecklist" replace />
    ) : commonUtils.isAdmin() && commonUtils.hasManageTicketPermission() ? (
      <Navigate to="/setting/ManageTicket" replace />
    ) : (
      <Masterpage />
    );
  }

  function RedirectToPublicSearch() {
    const location = useLocation();

    return <Navigate to={`/public/search${location.search}`} replace />;
  }

  return (
    <>
      <Route
        path="/equipmentGrpEqiupment"
        element={<PrivateRoute component={Dashboard} />}
      />
      <Route
        path="/inspection"
        element={<PrivateRoute component={Dashboard} />}
      />
      <Route
        path="/dashboard"
        element={<PrivateRoute component={GraphDashboard} />}
      />
      <Route
        path="/setting"
        element={<PrivateRoute component={ConditionalRoute} />}
      />
      <Route
        path="/setting/masterpage"
        element={<PrivateRoute component={ConditionalRoute} />}
      />
      <Route
        path="/setting/equipmentGroup"
        element={<PrivateRoute component={EquipmentGroup} />}
      />
      <Route
        path="/setting/plant"
        element={<PrivateRoute component={Plant} />}
      />
      <Route
        path="/setting/addCostCenter"
        element={<PrivateRoute component={AddCostCenter} />}
      />
      <Route
        path="/setting/costCenter"
        element={<PrivateRoute component={CostCenter} />}
      />
      <Route
        path="/setting/building"
        element={<PrivateRoute component={BuildingList} />}
      />
      <Route
        path="/setting/equipmentList"
        element={<PrivateRoute component={EquipmentList} />}
      />
      <Route
        path="/setting/herstellerList"
        element={<PrivateRoute component={HerstellerList} />}
      />
      <Route
        path="/setting/standardAttributeList"
        element={<PrivateRoute component={StandardAttributeList} />}
      />
      <Route
        path="/setting/pruefGroup"
        element={<PrivateRoute component={PruefGroup} />}
      />
      <Route
        path="/setting/digitalChecklist"
        element={<PrivateRoute component={DigitalCheckList} />}
      />
      <Route
        path="/setting/bezeichnungList"
        element={<PrivateRoute component={BezeichnungList} />}
      />
      <Route
        path="/organizationsadmin"
        element={<PrivateRoute component={OrganizationsAdmin} />}
      />
      <Route
        path="/performanceAnalysis"
        element={<PrivateRoute component={PerformanceAnalysis} />}
      />
      <Route
        path="/exceptionAnalysis"
        element={<PrivateRoute component={ExceptionAnalysis} />}
      />
      <Route
        path="/inspection/:equipmentGroup/:equipmentId/:bezeichnung/:inventarnr"
        element={<PrivateRoute component={EquipmentDetails} />}
      />
      <Route
        path="/inspection/:equipmentGroup/:parentequipmentId/:parentbezeichnung/:parentinventarnr/:equipmentId/:bezeichnung/:inventarnr"
        element={<PrivateRoute component={EquipmentDetails} />}
      />
      <Route
        path="/inspection/:equipmentGroup/:fonctionid/:fonctionsname/:equipmentId/:bezeichnung/:inventarnr"
        element={<PrivateRoute component={EquipmentDetails} />}
      />
      <Route
        path="/inspection/:equipmentGroup/:fonctionid/:fonctionsname/:parentequipmentId/:parentbezeichnung/:parentinventarnr/:equipmentId/:bezeichnung/:inventarnr"
        element={<PrivateRoute component={EquipmentDetails} />}
      />
      <Route
        path="/equipmentGrpEqiupment/:equipmentGroup/:equipmentId/:bezeichnung/:inventarnr"
        element={<PrivateRoute component={EquipmentDetails} />}
      />
      <Route
        path="/equipmentGrpEqiupment/:equipmentGroup/:parentequipmentId/:parentbezeichnung/:parentinventarnr/:equipmentId/:bezeichnung/:inventarnr"
        element={<PrivateRoute component={EquipmentDetails} />}
      />
      <Route
        path="/equipmentGrpEqiupment/:equipmentGroup/:fonctionid/:fonctionsname/:equipmentId/:bezeichnung/:inventarnr"
        element={<PrivateRoute component={EquipmentDetails} />}
      />
      <Route
        path="/equipmentGrpEqiupment/:equipmentGroup/:fonctionid/:fonctionsname/:parentequipmentId/:parentbezeichnung/:parentinventarnr/:equipmentId/:bezeichnung/:inventarnr"
        element={<PrivateRoute component={EquipmentDetails} />}
      />
      <Route
        path="/equipmentGrpEqiupment/AddEquipment/:equipmentGroup"
        element={<PrivateRoute component={AddEquipment} />}
      />
      <Route
        path="/equipmentGrpEqiupment/:equipmentGroup/:fonctionid/:fonctionsname"
        element={<PrivateRoute component={NavDetails} />}
      />
      <Route
        path="/dashboard/benutzerverwaltung"
        element={<PrivateRoute component={Benutzerverwaltung} />}
      />
      <Route
        path="/graphDashboard"
        element={<PrivateRoute component={GraphDashboard} />}
      />
      <Route
        path="/setting/organizationSetting"
        element={<PrivateRoute component={OrganisationSettings} />}
      />
      <Route
        path="/setting/audit"
        element={<PrivateRoute component={Audit} />}
      />
      <Route
        path="/setting/import"
        element={<PrivateRoute component={ImportExcel} />}
      />
      <Route
        path="/setting/export"
        element={<PrivateRoute component={ExportOrganisationData} />}
      />
      <Route
        path="/setting/feedBack"
        element={<PrivateRoute component={FeedBackList} />}
      />
      <Route
        path="/setting/emailList"
        element={<PrivateRoute component={EmailIndex} />}
      />
      <Route
        path="/unSync"
        element={<PrivateRoute component={NotPassedInspection} />}
      />
      <Route
        path="/setting/configValidation"
        element={<PrivateRoute component={ConfigurationValidationList} />}
      />
      <Route
        path="/setting/manageTicket"
        element={<PrivateRoute component={ManageTicket} />}
      />
      <Route
        path="/setting/CostCenterGroup"
        element={<PrivateRoute component={CostCenterGroup} />}
      />
      <Route
        path="/setting/inspectionReports"
        element={<PrivateRoute component={InspectionReports} />}
      />
      <Route path="/public/search" element={<SearchEquipment />} />

      <Route path="/puplic/search" element={<RedirectToPublicSearch />} />

      <Route path="/ticketDetails" element={<PublicAccess />} />
      <Route
        path="/setting/scrappedEquipments"
        element={<PrivateRoute component={ScrappedEquipments} />}
      />
    </>
  );
}
